module.exports = __webpack_public_path__ + "images/9681430a32cbe50be8d7640805be0f2e.webp";